module.exports = __webpack_public_path__ + "shattered.ea2316224d45899c59bc.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/assets/styles/patterns/shattered.png
// module id = ../../../../../src/assets/styles/patterns/shattered.png
// module chunks = styles